/**
 * 欢迎页运营位 + 设备：全页只拉一次，再下发给各卡片。
 * 首屏接口划分：运营位属核心路径，走 30s 共享缓存去重，避免轮播/专题重复请求。
 */
import { fetchSharedActiveOperationSlots } from './homeOperationSlotsShared';
import { farmSmartDeviceApi } from './farmSmartDevice';
import { iotAccessApi } from './iotAccess';
import { resolveTenantId } from '../utils/tenantParams.js';
import { isLoggedIn } from '../utils/token.js';

function parseDeviceList(res) {
  const body = res?.data;
  if (body?.success && Array.isArray(body.data)) return body.data;
  if (Array.isArray(body)) return body;
  return [];
}

function parseIotDeviceList(res) {
  const body = res?.data;
  if (body?.success && Array.isArray(body.data)) return body.data;
  return [];
}

function deviceIsOnline(d) {
  if (!d) return false;
  if (d.online === true || d.onlineStatus === true || d.isOnline === true) return true;
  const s = String(d.status || d.onlineStatus || '').toUpperCase();
  return s === 'ONLINE' || s === '1' || s === 'ON';
}

/** @returns {Promise<{ carousel: any[], topic: any[] }>} */
export async function loadWelcomeOperationSlots() {
  // 复用 homeOperationSlotsShared：30s 内多入口只打一次 /welcome/operation-slots
  const res = await fetchSharedActiveOperationSlots();
  const data = res?.data?.data || {};
  return {
    carousel: Array.isArray(data.carousel) ? data.carousel : [],
    topic: Array.isArray(data.topic) ? data.topic : [],
  };
}

/**
 * 智能设备台账 + IoT 设备各请求一次。
 * @returns {Promise<{ devices: any[], iotDevices: any[], devicesOnline: number }>}
 */
export async function loadWelcomeDevices() {
  if (!isLoggedIn()) {
    return { devices: [], iotDevices: [], devicesOnline: 0 };
  }
  const tid = resolveTenantId() || 'default';
  const [listRes, iotRes] = await Promise.all([
    farmSmartDeviceApi.list().catch(() => null),
    iotAccessApi.listDevices(tid).catch(() => null),
  ]);
  const devices = parseDeviceList(listRes);
  const iotDevices = parseIotDeviceList(iotRes);
  const farmOnline = devices.filter((d) => deviceIsOnline(d)).length;
  const iotOnline = iotDevices.filter((d) => d?.onlineStatus === true || deviceIsOnline(d)).length;
  return {
    devices,
    iotDevices,
    devicesOnline: farmOnline + iotOnline,
  };
}

export function computeDeviceStatusStats(devices = [], iotDevices = []) {
  const farmTotal = devices.length;
  const farmOnline = devices.filter((d) => deviceIsOnline(d)).length;
  const iotTotal = iotDevices.length;
  const iotOnline = iotDevices.filter((d) => d?.onlineStatus === true || deviceIsOnline(d)).length;
  const total = farmTotal + iotTotal;
  const online = farmOnline + iotOnline;
  const offline = Math.max(0, total - online);
  const alert = devices.filter((d) => String(d?.workStatus || '').toUpperCase() === 'FAULT').length;
  return { total, online, offline, alert };
}
